import React from 'react';
import '../styles/HowToPlayModal.css';

const HowToPlayModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target.className === 'howtoplay-modal-backdrop') {
      onClose();
    }
  };

  return (
    <div className="howtoplay-modal-backdrop" onClick={handleBackdropClick}>
      <div className="howtoplay-modal">
        <button className="howtoplay-modal-close" onClick={onClose}>×</button>
        
        <h2 className="howtoplay-title">How to Play</h2>
        
        <div className="howtoplay-content">
          <section className="howtoplay-section">
            <h3>🎯 Objective</h3>
            <p>Guess the mystery Skylander in 6 tries or less! A new Skylander is available every day at midnight.</p>
          </section>

          <section className="howtoplay-section">
            <h3>🎮 How to Play</h3>
            <p>Type a Skylander name and press Enter to submit your guess. After each guess, you'll see color-coded feedback for each attribute</p>
            <p>On mobile devices, scroll the table to see all the attributes</p>
            <p>Currently, only Skylanders from the first three games are available</p>
          </section>

          <section className="howtoplay-section">
            <h3>🔥 Element Relationships</h3>
            <p>All elements are connected! If your element guess points to the correct element, it will show as yellow on the table. Check the element chart to see which elements are connected.</p>
          </section>

          <section className="howtoplay-section">
            <h3>💾 Save Your Progress</h3>
            <p>Sign in to save your stats and game history across devices! Guest progress is saved locally on this device only.</p>
          </section>

          <div className="howtoplay-footer">
            <p>Good luck, Portal Master! 🌟</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayModal;
